import { render, staticRenderFns } from "./HistoricalTraffic.vue?vue&type=template&id=5b898d8a&scoped=true"
import script from "./HistoricalTraffic.vue?vue&type=script&lang=js"
export * from "./HistoricalTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b898d8a",
  null
  
)

export default component.exports